/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Why_Listening_Bento_DescriptionInputs */

const en_why_listening_bento_description = /** @type {(inputs: Why_Listening_Bento_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Papers, the articles around them and the newsletters you subscribe to, in one app that knows what not to read aloud.`)
};

const es_why_listening_bento_description = /** @type {(inputs: Why_Listening_Bento_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Artículos académicos, los textos que los rodean y las newsletters a las que te suscribes, en una app que sabe qué no leer en voz alta.`)
};

/**
* | output |
* | --- |
* | "Papers, the articles around them and the newsletters you subscribe to, in one app that knows what not to read aloud." |
*
* @param {Why_Listening_Bento_DescriptionInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const why_listening_bento_description = /** @type {((inputs?: Why_Listening_Bento_DescriptionInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Why_Listening_Bento_DescriptionInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_why_listening_bento_description(inputs)
	return en_why_listening_bento_description(inputs)
});